/**
 * Silently update current history frame state preserving react-router state structure without triggering react-router events
 * @desc Because React-Router doesn't have `history.replaceState` implementation and occupies history frame state with its format we need to implement this method to follow this format.
 * @param state
 * @param unused
 * @param [url]
 */
export const replaceRouterState = (state, unused, url) => {
  if (!window.history.state) {
    return;
  }

  const { idx, key } = window.history.state;

  window.history.replaceState({ idx, key, usr: state }, unused, url);
};
